/**
 * localStorageのkey
 */
export const LS_KEY = {
  lang: 'lang',
} as const;
